<template>
  <div>
    <div class="setting-field">
      <el-badge
          class="label">
        <label> Subscription </label>
      </el-badge>
      <el-switch
          v-model="triggersSubscription"
          :disabled="true"
          @change="onTriggersSubscriptionChange" />
      <span>{{ triggersSubscription ? 'on' : 'off' }}</span>
    </div>

    <h3>Triggers</h3>
    <div class="setting-field">
      <el-badge
          class="label">
        <label> Trigger </label>
      </el-badge>
      <el-select
          v-model="selectedTriggerId"
          placeholder="Select Trigger"
          size="small"
          @change="onTriggerChange">
        <el-option
            v-for="trigger in triggers"
            :key="trigger.id"
            :label="trigger.name"
            :value="trigger.id" />
      </el-select>

      <!--el-popover
          v-model="newTriggerPopOver.visible"
          width="444"
          style="margin-left: 0;">
        <div class="new-trigger-text__textarea">
          <el-input
              v-model="newTriggerPopOver.text"
              placeholder="Write your new trigger name" />
        </div>
        <div style="text-align: right; margin: 0">
          <el-button
              size="mini"
              type="text"
              @click="resetNewTrigger()">
            cancel
          </el-button>
          <el-button
              type="primary"
              size="mini"
              @click="createNewTrigger()">
            save
          </el-button>
        </div>

        <div
            slot="reference">
          <el-button
              style="position: absolute; right: 0; margin-top: 5px; margin-bottom: 38px;"
              size="small"
              type="primary">
            New
          </el-button>
        </div>
      </el-popover-->

      <!--el-badge
          class="label">
        <label> Id </label>
      </el-badge>
      <el-input
          v-model="selectedTriggerNew.id"
          size="small"
          placeholder="Id"
          :disabled="true"
          inline-message="true" /-->

      <el-badge
          class="label">
        <label> Name </label>
      </el-badge>
      <el-input
          v-model="selectedTriggerNew.name"
          size="small"
          placeholder="Name"
          :disabled="!selectedTriggerId"
          inline-message="true" />

      <!--el-badge
          class="label">
        <label> Mode </label>
      </el-badge>
      <el-select
          v-model="selectedTriggerNew.mode"
          placeholder="Select Mode"
          :disabled="true"
          size="small">
        <el-option
            v-for="mode in modes"
            :key="mode"
            :label="mode"
            :value="mode" />
      </el-select-->

      <!--el-badge
          class="label">
        <label> Setup State </label>
      </el-badge>
      <el-select
          v-model="selectedTriggerNew.setup_state"
          placeholder="Select Setup State"
          :disabled="!selectedTriggerId"
          size="small">
        <el-option
            v-for="setupState in setupStates"
            :key="setupState"
            :label="setupState"
            :value="setupState" />
      </el-select-->

      <div class="buttons-container">
        <el-button
            type="success"
            style="font-weight: 400;"
            size="small"
            :disabled="!selectedTriggerId"
            @click="saveCurrentTrigger()">
          Save
        </el-button>
        <el-button
            type="danger"
            style="font-weight: 400;"
            size="small"
            :disabled="!selectedTriggerId"
            @click="deleteCurrentTrigger()">
          Delete
        </el-button>
      </div>
    </div>

    <h3>States</h3>
    <div class="setting-field">
      <el-badge
          class="label">
        <label> State </label>
      </el-badge>
      <el-select
          v-model="selectedStateId"
          placeholder="Select State"
          :disabled="!selectedTriggerId"
          size="small"
          @change="onStateChange">
        <el-option
            v-for="state in states"
            :key="state.id"
            :label="state.name"
            :value="state.id" />
      </el-select>

      <!--el-popover
          v-model="newStatePopOver.visible"
          width="444"
          style="margin-left: 0;">
        <div class="new-state-text__textarea">
          <el-input
              v-model="newStatePopOver.text"
              placeholder="Write your new state name" />
        </div>
        <div style="text-align: right; margin: 0">
          <el-button
              size="mini"
              type="text"
              @click="resetNewState()">
            cancel
          </el-button>
          <el-button
              type="primary"
              size="mini"
              @click="createNewState()">
            save
          </el-button>
        </div>

        <div
            slot="reference">
          <el-button
              style="position: absolute; right: 0; margin-top: 5px; margin-bottom: 38px;"
              :disabled="!selectedTriggerId"
              type="primary"
              size="small">
            New
          </el-button>
        </div>
      </el-popover-->

      <!--el-badge
          class="label">
        <label> Id </label>
      </el-badge>
      <el-input
          v-model="selectedStateNew.id"
          size="small"
          placeholder="Id"
          :disabled="true"
          inline-message="true" /-->

      <el-badge
          class="label">
        <label> Name </label>
      </el-badge>
      <el-input
          v-model="selectedStateNew.name"
          size="small"
          placeholder="Name"
          :disabled="!selectedStateId"
          inline-message="true" />

      <el-badge
          class="label">
        <label> Enabled </label>
      </el-badge>
      <el-switch
          v-model="selectedStateNew.enabled"
          :disabled="!selectedStateId" />
      <span>{{ selectedStateNew.enabled ? 'on' : 'off' }}</span>

      <el-badge
          class="label">
        <label> Notification </label>
      </el-badge>
      <el-switch
          v-model="selectedStateNew.notification"
          :disabled="!selectedStateId" />
      <span>{{ selectedStateNew.notification ? 'on' : 'off' }}</span>

      <!--el-badge
          class="label">
        <label> Threshold </label>
      </el-badge>
      <el-input
          v-model="selectedStateNew.threshold"
          size="small"
          :disabled="!selectedStateId"
          inline-message="true" /-->

      <div class="buttons-container">
        <el-button
            type="success"
            style="font-weight: 400;"
            size="small"
            :disabled="!selectedStateId"
            @click="saveCurrentState()">
          Save
        </el-button>
        <el-button
            type="danger"
            style="font-weight: 400;"
            size="small"
            :disabled="!selectedStateId"
            @click="deleteCurrentState()">
          Delete
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { get, values } from "lodash";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapActions } = createNamespacedHelpers("db/device");

export default {
  name: "ComputerVision",
  props: {
    config: {
      type: Object,
      required: true,
    },
    paidFeatures: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      forceRecompute: 0,
      triggersSubscription: false,
      newTriggerPopOver: {
        visible: false,
        text: "",
      },
      selectedTriggerId: null,
      selectedTriggerNew: {
        id: "",
        name: "",
        mode: "",
        setup_state: "",
      },
      newStatePopOver: {
        visible: false,
        text: "",
      },
      selectedStateId: null,
      selectedStateNew: {
        id: "",
        name: "",
        enabled: false,
        notification: false,
        threshold: 0,
      },
      data: {
        triggers: [],
      },
    };
  },
  computed: {
    ...mapGetters(["doorbotId"]),
    triggers() {
      this.forceRecompute;
      return this.data.triggers;
    },
    states() {
      this.forceRecompute;

      if (this.selectedTriggerId) {
        const trigger = this.data.triggers.find(
          (trigger) => trigger.id === this.selectedTriggerId
        );
        return trigger.states;
      } else {
        return [];
      }
    },
    modes() {
      return ["edge", "cloud"];
    },
    setupStates() {
      return [
        "in_progress",
        "evaluation_in_progress",
        "evaluation_failed",
        "training_in_progress",
        "training_failed",
        "training_done",
        "done",
        "camera_moved",
      ];
    },
  },
  mounted() {
    this.data.triggers = this.config.value.triggers;
    if (!Array.isArray(this.data.triggers)) this.data.triggers = [];
    this.triggersSubscription = get(this.paidFeatures, "cv_triggers", false);
  },
  methods: {
    ...mapActions([
      "updateDevice",
      "createTrigger",
      "updateTrigger",
      "deleteTrigger",
      "createTriggerState",
      "updateTriggerState",
      "deleteTriggerState",
    ]),
    onTriggersSubscriptionChange(value) {
      const payload = {
        backend_settings: { paid_features: { cv_triggers: value } },
      };
      this.updateDevice({ doorbotId: this.doorbotId, payload })
        .then((response) => {
          this.triggersSubscription = value;
          this.$message({
            showClose: true,
            message: "Trigger saved successfully",
            type: "success",
          });
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: "Trigger saving error",
            type: "error",
          });
        });
    },
    onTriggerChange(triggerId) {
      this.selectedTriggerNew = Object.assign(
        {},
        this.data.triggers.find((trigger) => trigger.id === triggerId)
      );
      this.selectedStateId = null;
      this.selectedStateNew = {
        id: "",
        name: "",
        enabled: false,
        notification: false,
        threshold: 0,
      };
    },
    onStateChange(stateId) {
      const trigger = this.data.triggers.find(
        (trigger) => trigger.id === this.selectedTriggerId
      );
      this.selectedStateNew = Object.assign(
        {},
        trigger.states.find((state) => state.id === stateId)
      );
    },
    createNewTrigger() {
      this.selectedTriggerNew = {
        id: "",
        name: this.newTriggerPopOver.text,
        mode: "",
        setup_state: "",
        states: {},
      };
      this.createTrigger({
        doorbotId: this.doorbotId,
        payload: {
          trigger: this.selectedTriggerNew,
        },
      })
        .then((response) => {
          this.selectedTriggerNew = response.data.triggers[0];
          this.data.triggers.push(this.selectedTriggerNew);
          this.selectedTriggerId = this.selectedTriggerNew.id;
          this.forceRecompute++;
          this.resetNewTrigger();
          this.$message({
            showClose: true,
            message: "Trigger saved successfully",
            type: "success",
          });
        })
        .catch((_error) => {
          this.$message({
            showClose: true,
            message: "Trigger saving error",
            type: "error",
          });
        });
    },
    deleteCurrentTrigger() {
      this.deleteTrigger({
        doorbotId: this.doorbotId,
        triggerId: this.selectedTriggerId,
      })
        .then((response) => {
          this.data.triggers = this.data.triggers.filter(
            (trigger) => trigger.id !== this.selectedTriggerId
          );
          this.selectedTriggerNew = {
            id: "",
            name: "",
            mode: "",
            setup_state: "",
            states: {},
          };
          this.selectedTriggerId = null;
          this.forceRecompute++;
          this.$message({
            showClose: true,
            message: "Trigger deleted successfully",
            type: "success",
          });
        })
        .catch((_error) => {
          this.$message({
            showClose: true,
            message: "Trigger deletion error",
            type: "error",
          });
        });
    },
    saveCurrentTrigger() {
      this.updateTrigger({
        doorbotId: this.doorbotId,
        triggerId: this.selectedTriggerId,
        payload: {
          trigger: this.selectedTriggerNew,
        },
      })
        .then((response) => {
          this.selectedTriggerNew = response.data;
          const triggerIndex = this.data.triggers.findIndex(
            (trigger) => trigger.id === this.selectedTriggerId
          );
          this.data.triggers[triggerIndex] = Object.assign(
            {},
            this.selectedTriggerNew
          );
          this.selectedTriggerId = this.selectedTriggerNew.id;
          this.forceRecompute++;
          this.newTriggerPopOver.visible = false;
          this.$message({
            showClose: true,
            message: "Trigger saved successfully",
            type: "success",
          });
        })
        .catch((_error) => {
          this.$message({
            showClose: true,
            message: "Trigger saving error",
            type: "error",
          });
        });
    },
    resetNewTrigger() {
      this.newTriggerPopOver = {
        visible: false,
        text: "",
      };
    },
    createNewState() {
      this.selectedStateNew = {
        id: this.newStatePopOver.text,
        name: this.newStatePopOver.text,
        enabled: false,
        notification: false,
        threshold: 0,
      };
      this.createTriggerState({
        doorbotId: this.doorbotId,
        triggerId: this.selectedTriggerId,
        payload: {
          trigger_state: this.selectedStateNew,
        },
      })
        .then((response) => {
          this.selectedStateNew = response.data.states[0];
          const triggerIndex = this.data.triggers.findIndex(
            (trigger) => trigger.id === this.selectedTriggerId
          );
          if (this.data.triggers[triggerIndex].states) {
            this.data.triggers[triggerIndex].states.push(
              Object.assign({}, this.selectedStateNew)
            );
          } else {
            this.data.triggers[triggerIndex].states = [
              Object.assign({}, this.selectedStateNew),
            ];
          }
          this.selectedStateId = this.selectedStateNew.id;
          this.forceRecompute++;
          this.resetNewState();
          this.$message({
            showClose: true,
            message: "State saved successfully",
            type: "success",
          });
        })
        .catch((_error) => {
          this.$message({
            showClose: true,
            message: "State saving error",
            type: "error",
          });
        });
    },
    deleteCurrentState() {
      this.deleteTriggerState({
        doorbotId: this.doorbotId,
        triggerId: this.selectedTriggerId,
        stateId: this.selectedStateId,
      })
        .then((response) => {
          const triggerIndex = this.data.triggers.findIndex(
            (trigger) => trigger.id === this.selectedTriggerId
          );
          this.data.triggers[triggerIndex].states = this.data.triggers[
            triggerIndex
          ].states.filter((state) => state.id !== this.selectedStateId);
          this.selectedStateNew = {
            id: "",
            name: "",
            enabled: false,
            notification: false,
            threshold: 0,
          };
          this.selectedStateId = null;
          this.forceRecompute++;
          this.$message({
            showClose: true,
            message: "State deleted successfully",
            type: "success",
          });
        })
        .catch((_error) => {
          this.$message({
            showClose: true,
            message: "State deletion error",
            type: "error",
          });
        });
    },
    saveCurrentState() {
      this.updateTriggerState({
        doorbotId: this.doorbotId,
        triggerId: this.selectedTriggerId,
        stateId: this.selectedStateId,
        payload: { trigger_state: this.selectedStateNew },
      })
        .then((response) => {
          this.$message({
            showClose: true,
            message: "State saved successfully",
            type: "success",
          });
        })
        .catch((_error) => {
          this.$message({
            showClose: true,
            message: "State saving error",
            type: "error",
          });
        });
    },
    resetNewState() {
      this.newStatePopOver = {
        visible: false,
        text: "",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "settings";
@include settingField();
.new-trigger-text__textarea,
.new-state-text__textarea {
  margin: 24px 16px;
}
.buttons-container {
  margin-top: 20px;
  text-align: center;
}
</style>
